import { openBlock as t, createElementBlock as r, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, l) {
  return t(), r("svg", o, [...l[0] || (l[0] = [
    e("g", { "clip-path": "url(#a)" }, [
      e("path", {
        fill: "currentColor",
        d: "m9.97 13.041 2.03-1.54 2.021 1.54-.77-2.494 2.03-1.61h-2.485L12 6.48l-.796 2.459H8.719l2.021 1.61zM19 9.812c0-3.867-3.133-7-7-7s-7 3.133-7 7c0 1.777.665 3.387 1.75 4.62v6.756l5.25-1.75 5.25 1.75v-6.755A6.97 6.97 0 0 0 19 9.813m-7-5.25a5.254 5.254 0 0 1 5.25 5.25 5.254 5.254 0 0 1-5.25 5.25 5.254 5.254 0 0 1-5.25-5.25A5.254 5.254 0 0 1 12 4.563"
      })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const d = { render: n };
export {
  d as default,
  n as render
};
